import React, { useState } from "react";
import { Dialog, DialogContent } from "./ui/dialog";
import { Coins, Plus, ArrowDownToLine, Lock } from "lucide-react";

const PACKAGES = [
  { coins: 10, price: "£10" },
  { coins: 25, price: "£25" },
  { coins: 50, price: "£50" },
  { coins: 100, price: "£100" },
];

const ComingSoon = () => (
  <div className="flex items-center justify-center gap-1.5 rounded-lg bg-[#10B981]/10 border border-[#10B981]/25 px-3 py-2 text-[#10B981] text-xs font-semibold mt-4">
    <Lock className="w-3.5 h-3.5" /> Coming soon
  </div>
);

const WalletModal = ({ open, onClose, coins }) => {
  const [tab, setTab] = useState("buy");

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="theme-light bg-[#1E293B] border border-white/10 text-white w-[calc(100%-2rem)] max-w-sm p-0 overflow-hidden rounded-2xl">
        <div className="p-5">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 rounded-xl bg-[#10B981]/12 border border-[#10B981]/30 px-3 py-1.5">
              <Coins className="w-5 h-5 text-[#10B981]" />
              <span className="font-display font-bold text-lg text-[#10B981]">£{coins?.toLocaleString()}</span>
              <span data-testid="virtual-tag" className="ml-0.5 rounded-md bg-[#38BDF8]/15 text-[#38BDF8] text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5">virtual</span>
            </div>
          </div>

          <div className="inline-flex items-center gap-1 rounded-xl bg-white/5 border border-white/10 p-1 mt-4 w-full">
            {[
              { id: "buy", label: "Top up" },
              { id: "withdraw", label: "Withdraw" },
            ].map((t) => (
              <button
                key={t.id}
                data-testid={`wallet-tab-${t.id}`}
                onClick={() => setTab(t.id)}
                className={`flex-1 rounded-lg py-2 text-sm font-semibold transition-colors flex items-center justify-center gap-1.5 ${
                  tab === t.id ? "bg-[#10B981] text-[#0F172A]" : "text-slate-300 hover:text-white"
                }`}
              >
                {t.label}
                <Lock className="w-3 h-3 opacity-70" />
              </button>
            ))}
          </div>

          {tab === "buy" ? (
            <>
              <div className="grid grid-cols-2 gap-3 mt-4" data-testid="wallet-buy-locked">
                {PACKAGES.map((p) => (
                  <div
                    key={p.coins}
                    className="relative rounded-xl border border-white/10 bg-white/5 p-4 text-center opacity-60 cursor-not-allowed select-none"
                  >
                    <div className="absolute top-2 right-2 text-slate-500">
                      <Lock className="w-3.5 h-3.5" />
                    </div>
                    <div className="flex items-center justify-center gap-1 font-display font-bold text-xl text-[#10B981]">
                      <Plus className="w-4 h-4" />
                      £{p.coins.toLocaleString()}
                    </div>
                    <div className="text-slate-400 text-xs mt-1">Coming soon</div>
                  </div>
                ))}
              </div>
              <ComingSoon />
            </>
          ) : (
            <div className="mt-4" data-testid="wallet-withdraw-locked">
              <div className="flex items-center gap-3 rounded-xl bg-white/5 border border-white/10 px-4 py-3 opacity-60">
                <ArrowDownToLine className="w-4 h-4 text-slate-500" />
                <input
                  type="number"
                  disabled
                  placeholder="£ to withdraw"
                  className="w-full bg-transparent outline-none text-white placeholder-gray-500 cursor-not-allowed"
                />
                <Lock className="w-4 h-4 text-slate-500 shrink-0" />
              </div>
              <button
                disabled
                data-testid="wallet-cashout-locked"
                className="w-full rounded-xl py-3 font-semibold mt-3 bg-white/5 text-slate-500 border border-white/10 cursor-not-allowed flex items-center justify-center gap-2"
              >
                <Lock className="w-4 h-4" /> Cash out
              </button>
              <ComingSoon />
            </div>
          )}

          <p className="text-slate-500 text-[11px] text-center mt-4">
            Topping up and withdrawing is coming soon. Your £ balance is virtual money only — no real payment is taken and no real money is paid out.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WalletModal;
